import DataSource from "devextreme/data/data_source";
import { useQuery } from "react-query";
import { atom } from "recoil";
import { loadFn, Params } from "shared/component/dxf-map/dxf-map";
import { client } from "shared/helpers/client";



export const balanceFilterAtom = atom({
  key: "balance-filter",
  default: {
    filter:{"StartDate":{"operator":"Equals","value":"2020-10-11T00:00:00+02:00"},"EndDate":{"operator":"Equals","value":"2022-10-11T00:00:00+02:00"}}
  }
});

export const getMyBalance=(params: Params)=> {
  return client<any[]>('/OwnerBooking/getMyBalance', { params})
}



  export const useBalanceSource = (filter:any) => new DataSource({
    key: 'id',
    load: loadFn(p =>
        client('/OwnerBooking/getMyBalance', {
            params: {
                ...p,
                searchTerm:filter.filter
            },
        })
    ),
})

  export function usePreBalance(startDate:any) {
    const result = useQuery(['previuos-balance',startDate], async () => {
        const { response } = await client("/OwnerBooking/GetPreviuosBalance",{params:{startDate:startDate}})
        if (response) return response
    })
    return { ...result, preBalance: result.data ?? 0 }
}
